import React, { useEffect, useState } from 'react';
import { View, StyleSheet, Image, TouchableOpacity, SafeAreaView, FlatList } from 'react-native';
// import { useKeenSliderNative } from 'keen-slider/react-native';
import { BText, Page } from '../../components';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { EventModel } from '../../types';
import { setLoading } from '../../store/portal/portalActions';
import { EventCard } from '../../components/events/EventCard';
// import { fetchAllEvents } from '../../store/events/eventActions';
import eventThumbnail1 from '../../assets/images/event_thumbnail_icon.png';
// import eventThumbnail2 from '../../assets/images/event_thumbnail_icon.png';
// import eventThumbnail3 from '../../assets/images/event_thumbnail_icon.png';
import { fetchAllEvents } from '../../store/events/eventActions';

export const Home = ({ navigation }: any) => {
  const dispatch = useAppDispatch();
  const [rtPortal, rtEvents] = useAppSelector(s => [s.portal, s.event]);

  const [width, setWidth] = useState<number>(0);

  const categories = [
    { id: '1', image: eventThumbnail1, title: 'Community' },
    { id: '2', image: eventThumbnail1, title: 'Education' },
    { id: '3', image: eventThumbnail1, title: 'Science & Technology' },
    { id: '4', image: eventThumbnail1, title: 'Sports & Fitness' },
  ];

  // const [currentSlide, setCurrentSlide] = useState(0);
  // const carouselData = [
  //   { id: 0, image: eventThumbnail1, title: 'Example Event 1' },
  //   { id: 1, image: eventThumbnail2, title: 'Example Event 2' },
  //   { id: 2, image: eventThumbnail3, title: 'Example Event 3' },
  // ];
  // const slides = carouselData.length;
  // const slider = useKeenSliderNative({
  //   slides,
  //   loop: true,
  //   slideChanged() {
  //     setCurrentSlide(slider.track.details.rel);
  //   },
  // });

  useEffect(() => {
    if (!rtEvents.loaded) {
      dispatch(setLoading(true, 'Home []'));
      // Setting up data
      // Get master event data from API
      dispatch(
        fetchAllEvents({
          limit: 10,
          searchParam: {
            state: 'SGR',
            city: 'Puchong',
          },
          countToGet: 5,
        }),
      );
    }
  }, []);

  useEffect(() => {
    if (rtEvents.loaded) dispatch(setLoading(false, 'Home'));
  }, [rtEvents]);

  useEffect(() => {
    if (rtPortal.isSmallScreen) {
      setWidth(rtPortal.width - 2 * 16);
    } else {
      if (['md', 'lg'].includes(rtPortal.breakpoint)) {
        setWidth(rtPortal.width - 2 * 8);
      } else {
        setWidth(rtPortal.width - 2 * 8);
      }
    }
  }, [rtPortal.width]);

  const renderCategoryItem = ({ item }: { item: { id: string; image: string; title: string } }) => (
    <TouchableOpacity onPress={() => categoryOnClick(item)} style={homeStyle.gridCard}>
      <Image source={{ uri: item.image }} style={homeStyle.gridImage} />
      <BText style={homeStyle.gridImageText}>{item.title}</BText>
    </TouchableOpacity>
  );

  const categoryOnClick = (item: any) => {
    console.log('category onClick>>>', item);
  };

  // const carouselItemView = () => {
  //   return (
  //     <View style={homeStyle.slider} {...slider.containerProps}>
  //       {carouselData.map(data => (
  //         <View key={data.id} {...slider.slidesProps[data.id]} style={{ flexDirection: 'column' }}>
  //           <Image source={{ uri: data.image }} style={homeStyle.carouselImage} />
  //           <View style={homeStyle.carouselContent}>
  //             <BText style={homeStyle.carouselTitle}>{data.title}</BText>
  //             <BText style={homeStyle.carouselDescription} numberOfLines={3}>
  //               This is a long text that appears below the image in the carousel. This is a long text that appears below
  //               the image in the carousel. This is a long text that appears below the image in the carousel.
  //             </BText>
  //           </View>
  //         </View>
  //       ))}
  //     </View>
  //   );
  // };

  // const renderDotIndicator = () => {
  //   return (
  //     <View style={homeStyle.dotContainer}>
  //       {carouselData.map((item, index) => (
  //         <View
  //           key={item.id}
  //           style={[homeStyle.dot, index === currentSlide && homeStyle.dotActive]}
  //           // onPress={() => setCurrentSlide(index)}
  //         />
  //       ))}
  //     </View>
  //   );
  // };

  // const carouselItemOnClick = (item: any) => {
  //   console.log('category onClick>>>', item)
  // }

  return (
    <Page title={''}>
      <View style={[rtPortal.isSmallScreen ? homeStyle.containerSm : homeStyle.containerMd, { width: width }]}>
        {/* <View style={homeStyle.carouselContainer}>{carouselItemView()}</View>
        {renderDotIndicator()} */}
        <View style={homeStyle.gridTopTitle}>
          <BText style={{ alignSelf: 'flex-start', fontWeight: 'bold' }}>Browse by Category</BText>
          <TouchableOpacity>
            <BText style={{ alignSelf: 'flex-end', fontWeight: 'bold' }}>View All</BText>
          </TouchableOpacity>
        </View>
        <SafeAreaView style={homeStyle.gridContainer}>
          <FlatList
            data={categories}
            renderItem={renderCategoryItem}
            keyExtractor={item => item.id}
            numColumns={2}
            style={{ flex: 1 }}
            contentContainerStyle={{ paddingVertical: 10 }}
          />
        </SafeAreaView>
        <View style={homeStyle.gridTopTitle}>
          <BText style={{ alignSelf: 'flex-start', fontWeight: 'bold' }}>Latest Events</BText>
          <TouchableOpacity>
            <BText style={{ alignSelf: 'flex-end', fontWeight: 'bold' }}>View All</BText>
          </TouchableOpacity>
        </View>

        <View
          style={{
            flexDirection: 'column',
            marginStart: -8,
            marginEnd: 8,
            justifyContent: 'flex-start',
            alignItems: 'stretch',
          }}
        >
          {rtEvents.allEvents.map((event: EventModel, i: number) => {
            return <EventCard key={i} event={event} />;
          })}
        </View>
      </View>
    </Page>
  );
};

const homeStyle = StyleSheet.create({
  container: {
    flex: 1,
    marginTop: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  containerMd: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginHorizontal: -8,
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  containerSm: {
    flexDirection: 'column',
    marginHorizontal: 0,
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  gridTopTitle: {
    padding: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
    position: 'relative',
  },
  gridTopTitleText: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  gridContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  gridCard: {
    width: '48%',
    aspectRatio: 1.8,
    marginLeft: 5,
    marginBottom: 5,
    position: 'relative',
  },
  gridImage: {
    flex: 1,
    resizeMode: 'cover',
    borderRadius: 10,
  },
  gridImageText: {
    position: 'absolute',
    bottom: 8,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    color: 'white',
  },
  carouselContainer: {
    width: '100%',
    height: 300,
    overflow: 'hidden',
  },
  carouselSlide: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  carouselActiveSlide: {
    backgroundColor: 'lightgray',
  },
  carouselImage: {
    width: '100%',
    height: '70%',
    resizeMode: 'cover',
  },
  carouselTitle: {
    marginTop: 5,
    fontSize: 16,
    color: 'black',
  },
  carouselContent: {
    padding: 5,
    backgroundColor: 'white',
  },
  carouselDescription: {
    marginTop: 10,
    fontSize: 12,
    color: 'gray',
  },
  dotContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  dot: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: 'gray',
    margin: 5,
  },
  dotActive: {
    backgroundColor: 'black',
  },
  slider: {
    backgroundColor: '#fff',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    borderRadius: 10,
  },
  slide: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'black',
  },
});
